<template>
  <div class="help-box">
    <Header @change="languageChange" />

    <div class="help-nav">
      <div class="help-title">{{ $t(`help.help1`) }}</div>
      <div class="help-search">
        <a-input-search
          @search="openSearch"
          v-model:value="searchValue"
          :placeholder="$t(`tips.tip53`)"
        />
      </div>
      <div class="help-content">
        <a-row
          :gutter="[
            { lg: 60, sm: 16, xs: 16 },
            { lg: 48, sm: 16, xs: 16 },
          ]"
        >
          <a-col
            :lg="12"
            :sm="24"
            :xs="24"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="card-box">
              <div class="card-title">
                <div class="card-title-text">
                  <span class="iconfont icon-jiaocheng"></span>{{ item.title }}
                </div>
                <a class="all-btn" @click="handleClick(item)">
                  {{ $t(`help.help2`) }}
                  <span class="iconfont icon-arrow-right"></span
                ></a>
              </div>
              <div class="card-text">
                <div
                  class="card-text-item"
                  v-for="(child, i) in item.children"
                  :key="i"
                  @click="handleDetail(item, child.a_id)"
                >
                  <div class="card-text-title">
                    <span class="iconfont icon-dian"></span>{{ child.title }}
                  </div>
                  <div style="float: right; display: inline-block">
                    {{ formatDate(child.create_time) }}
                  </div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "./components/Header.vue";
import { useRouter, useRoute } from "vue-router";
import { formatDate } from "../../utils/formatTime";
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  onUnmounted,
} from "vue";
export default defineComponent({
  components: {
    Header,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    let globalProperties =
      getCurrentInstance().appContext.config.globalProperties;
    const axios = globalProperties.$axioshanma;
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      searchValue: "",
      list: [],
    });
    if (route.query.type) {
      localStorage.setItem("showPCHelpType", route.query.type);
    } else {
      if (localStorage.getItem("showPCHelpType")) {
        localStorage.removeItem("showPCHelpType");
      }
    }
    onMounted(() => {
      getList();
    });
    const getList = () => {
      axios("/api/ayuda.article/articleHomeList", {
        appid: "764e02x4-d252-11eb-af05-6cdc5827",
        page: 1,
        size: 5,
      }).then((res) => {
        state.list = res;
      });
    };

    const handleClick = (value) => {
      router.push({
        path: "/helpCatalog",
        query: {
          id: value.a_id,
        },
      });
    };
    const handleDetail = (val1, val2) => {
      router.push({
        path: "/helpDetail",
        query: {
          id: val2,
        },
      });
    };
    const languageChange = (val) => {
      getList();
    };
    const openSearch = () => {
      // let routeData = router.resolve({
      //   path: "/helpSearch",
      //   query: { searchValue: state.searchValue },
      // });
      // window.open(routeData.href, "_blank");
      router.push({
        path: "/helpSearch",
        query: { searchValue: state.searchValue },
      })
      state.searchValue = "";
    };

    return {
      router,
      ...toRefs(state),
      languageChange,
      handleClick,
      openSearch,
      formatDate,
      handleDetail,
    };
  },
});
</script>
<style scoped>
::v-deep(.ant-input-affix-wrapper) {
  width: 60%;
}
.icon-arrow-right {
  font-size: 16px;
}
.help-box {
  background: #f3f6fa;
  height: 100%;
  overflow-y: auto;
}
.help-nav {
  margin-top: 88px;
  width: 100%;
  background-image: url("../../assets/help-bg.png");
  background-size: 100% 280px;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 34px;
}
.help-title {
  height: 46px;
  font-size: 32px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 46px;
}
.help-search {
  width: 68%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}
.help-content {
  width: 60%;
  margin: 40px auto;
}
.card-box {
  height: 281px;
  background: #ffffff;
  border-radius: 8px;
  padding: 33px 32px 24px 32px;
}
.card-box:hover {
  box-shadow: 0px 4px 8px 0px rgba(145, 152, 165, 0.24);
}
.card-title {
  height: 28px;
  font-size: 18px;
  font-weight: 500;
  color: #1a1d21;
  line-height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-title-text {
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icon-jiaocheng {
  font-size: 24px;
  margin-right: 5px;
  float: left;
}
.card-text {
  padding-top: 16px;
}
.card-text-item {
  cursor: pointer;
  height: 28px;
  font-size: 16px;
  color: #535d6c;
  line-height: 28px;
  margin-bottom: 8px;
}
.icon-dian {
  font-size: 26px;
  color: #d6dce6;
  float: left;
}
.card-text-title {
  width: 60%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  word-break: break-all;
}

.all-btn {
  height: 22px;
  font-size: 16px;
  color: #003591;
  line-height: 22px;
  cursor: pointer;
  white-space: nowrap;
  text-align: right;
}
@media only screen and (max-width: 1300px) {
  .help-content {
    width: 70%;
    margin: 40px auto;
  }
}
@media only screen and (max-width: 992px) {
  ::v-deep(.ant-input-affix-wrapper) {
    width: 90%;
  }
  .help-box {
    height: auto;
  }
  .help-search {
    margin-top: 20px;
  }
  .help-content {
    width: 90%;
    margin: 20px auto;
  }
  .help-nav {
    margin-top: 55px;
    background-image: url("../../assets/help-bg.png");
    background-size: 100% 180px;
    padding-top: 22px;
  }
  .help-search {
    width: 100%;
  }
  .card-box {
    height: 271px;
    padding: 22px 22px 16px 22px;
  }
  .all-btn {
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
